export default "__VITE_ASSET__a7b1d062__"